import Header from '../components/Header/Header';
import KnowUs from '../components/KnowUs/KnowUs';
import Services from '../components/Services/Services';
import Mission from '../components/Mission/Mission';
import Products from '../components/Products/Products';
import Glowing from '../components/Glowing/Glowing';

const LandingPage = () => {
	return (
		<>
			<Header  />
			<KnowUs />
			<Services />
			<Mission />
			<Products />
			<Glowing />
		</>
	)
}

export default LandingPage